import BaseChoosePopup from "./BaseChoosePopup";

class ConfirmWin extends BaseChoosePopup
{
    constructor(leftCallback, rightCallback, textMsg)
    {
        super(leftCallback, rightCallback);

        this.textMsg = textMsg;
        this.topPadding = 8;
        this.bottomPadding = 12;
        this.leftPadding = this.rightPadding = 10;

        this.create();
    }


    init()
    {
        super.init();
        this.setText(this.textMsg);
    }


    drawAfterSizing()
    {
        this.drawButtons("Yes", "No");
    }

}

export default ConfirmWin;